/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsAndroidOptions
 */
export interface FxGamesLibWebPlatformDataOptionsAndroidOptions {
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPlatformDataOptionsAndroidOptions
     */
    PackageName: string;
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPlatformDataOptionsAndroidOptions
     */
    AndroidClass?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxGamesLibWebPlatformDataOptionsAndroidOptions
     */
    AppLinkUrl: string;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsAndroidOptions interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsAndroidOptions(value: object): value is FxGamesLibWebPlatformDataOptionsAndroidOptions {
    if (!('PackageName' in value) || value['PackageName'] === undefined) return false;
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsAndroidOptionsFromJSON(json: any): FxGamesLibWebPlatformDataOptionsAndroidOptions {
    return FxGamesLibWebPlatformDataOptionsAndroidOptionsFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsAndroidOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsAndroidOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'PackageName': json['PackageName'],
        'AndroidClass': json['AndroidClass'] == null ? undefined : json['AndroidClass'],
        'AppLinkUrl': json['AppLinkUrl'],
    };
}

export function FxGamesLibWebPlatformDataOptionsAndroidOptionsToJSON(json: any): FxGamesLibWebPlatformDataOptionsAndroidOptions {
    return FxGamesLibWebPlatformDataOptionsAndroidOptionsToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsAndroidOptionsToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsAndroidOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PackageName': value['PackageName'],
        'AndroidClass': value['AndroidClass'],
        'AppLinkUrl': value['AppLinkUrl'],
    };
}

